<template>
  <div id="JtBarChart">
    <v-chart ref="chart" class="jtchart" :option="chartSettings" autoresize />
  </div>
</template>

<script>
import { Component, Vue, Watch } from 'vue-property-decorator'
import JtBaseBarLineChart from './base/JtBaseBarLineChart.vue'

@Component({
  name: 'JtBarChart',
  mixins: [JtBaseBarLineChart],
  props: {
    centralTitle: {
      type: String,
      required: false,
      default: ''
    },
    centralTitleConst: {
      type: String,
      required: false,
      default: ''
    },
    shouldShowOverlappingBars: {
      type: Boolean,
      required: false,
      default: true
    }
  }
})
export default class JtBarChart extends Vue {
  created () {
    this.chartSettings.barGap = this.shouldShowOverlappingBars ? '-30%' : '30%'
    this.chartSettings.itemStyle = {
      borderRadius: [0, 5, 0, 0]
    }
    this.chartSettings.tooltip.trigger = 'item'
    this.chartSettings.xAxis.axisPointer = {
      type: 'shadow'
    }
    this.chartSettings.title.text = this.centralTitle || (this.centralTitleConst ? this.$gettext(this.centralTitleConst) : '')
  }
}
</script>

<style lang='stylus' scoped>
@import '~quasar-variables';

#JtBarChart {
  height: 100%;
  width: 100%;
}
</style>
